interface ActionTypes {
  USER_PLAN_UPGRADE_START: string;
  USER_PLAN_UPGRADE_SUCCESS: string;
  USER_PLAN_UPGRADE_FAILURE: string;
}

export const UpgradeActionTypes: ActionTypes = {
  USER_PLAN_UPGRADE_START: '@@USER_PLAN_UPGRADE_START',
  USER_PLAN_UPGRADE_SUCCESS: '@@USER_PLAN_UPGRADE_SUCCESS',
  USER_PLAN_UPGRADE_FAILURE: '@@USER_PLAN_UPGRADE_FAILURE'
};

export interface UpgradeState {
  upgradePlanResponse?: any;
  upgradePlanError?: any;
  submittingUpgrade?: boolean;
}
